import { Component, ComponentInterface, Prop, h, VNode } from '@stencil/core';

import { UniHostTemplate } from '@uiwebkit/common';
import { uniWatermark } from '@uni/license';

import { uniSelectionClass } from '../utils/selection.classes';

@Component({
  tag: 'uni-selection',
  styleUrl: '../styles/selection.css',
})
export class UniSelectionComponent implements ComponentInterface {

  @Prop({ reflect: true }) inactive: boolean = false;

  @Prop({ reflect: true }) outlined: boolean = false;

  render(): VNode {
    const classes = uniSelectionClass(!this.inactive, this.outlined);

    return UniHostTemplate({ classes }, <slot />);
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
